import React, { useEffect } from "react";
import Loader from "./components/Loader/Loader";
import { Footer } from "./components/Footer/Footer";
import * as Sentry from "@sentry/react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import ApplicationAll from "./components/ApplicationPages/ApplicationAll/ApplicationAll";
import WIPApplication from "./components/ApplicationPages/ApplicationAll/WIPApplication";
import PendingApplication from "./components/ApplicationPages/ApplicationAll/PendingApplication";
import IssuedApplication from "./components/ApplicationPages/ApplicationAll/IssuedApplication";
import RejectedApplication from "./components/ApplicationPages/ApplicationAll/RejectedApplication";
import FinalAppSubmission from "./components/FinalAppSubmission/FinalAppSubmission";
import ProposalHistory from "./components/ApplicationPages/ProposalHistory/ProposalHistory";

import RTSApplication from "./components/ApplicationPages/ApplicationAll/RTSApplication";

const LeadMaster = React.lazy(() => import("./containers/LeadMaster/index"));
const AdvisorMaster = React.lazy(() => import("./containers/AdvisorMaster/index"));
const NotificationComp = React.lazy(() => import("./components/NotificationComp/NotificationComp.js"));

const NeedAnalysis = React.lazy(() => import("./components/NeedAnalysis/NeedAnalysis"));
const ProductRecommendation = React.lazy(() => import("./components/NeedAnalysis/ProductRecommendation/ProductRecommendation"));
const Ekyc = React.lazy(() => import("./components/NeedAnalysis/ekyc/Ekyc"));
const LeadTracker = React.lazy(() => import("./components/LeadTracker/LeadTracker"));
const EInsurance = React.lazy(() => import("./components/ProposalFormFilling/EInsurance/EInsurance"));
const DetailsOfPlan = React.lazy(() => import("./components/ProposalFormFilling/DetailsOfPlan/DetailsOfPlan"));
const AboutCustomer_v2 = React.lazy(() => import("./components/ProposalFormFilling/AboutCustomer_v2/AboutCustomer_v2.js"));
const FinancialDetails = React.lazy(() => import("./components/ProposalFormFilling/FinancialDetails/FinancialDetails"));
const HealthDetails = React.lazy(() => import("./components/ProposalFormFilling/HealthDetails/HealthDetails"));
const PreviousPolicy = React.lazy(() => import("./components/ProposalFormFilling/PreviousPolicy/PreviousPolicy"));

const NominationDetails = React.lazy(() => import("./components/ProposalFormFilling/NominationDetails/NominationDetails2"));
const Declaration = React.lazy(() => import("./components/ProposalFormFilling/Declaration/Declaration"));
const ProposerDetails = React.lazy(() => import("./components/ProposalFormFilling/ProposerDetails/ProposerDetails"));
const PersonalDetails = React.lazy(() => import("./components/LeadDetails/PersonalDetails/PersonalDetails"));
const ContactDetails = React.lazy(() => import("./components/LeadDetails/ContactDetails/ContactDetails"));
const ProfessionalDetails = React.lazy(() => import("./components/LeadDetails/ProfessionalDetails/ProfessionalDeatils"));
const ExistingInsurance = React.lazy(() => import("./components/LeadDetails/ExistingInsurance/ExistingInsurance"));

const AdditionalDetails = React.lazy(() => import("./components/LeadDetails/AdditionalDetails/AdditionalDetails"));

const Login_v2 = React.lazy(() => import("./components/Login/Login_v2"));
const DefaultPage = React.lazy(() => import("./components/Login/DefaultPage"));
const ForgotPassword = React.lazy(() => import("./components/ForgotPassword/ForgotPassword"));

const CustomerReview = React.lazy(() => import("./components/CustomerReview/CustomerReview"));
const ChangePassword = React.lazy(() => import("./components/ChangePassword/ChangePassword"));
const Sidebar = React.lazy(() => import("./components/SideBar/SideBar"));

const HomePage = React.lazy(() => import("./components/Home/HomePage"));

const LoanProducts = React.lazy(() => import("./components/Products/LoanProducts"));
const RecommentedProducts = React.lazy(() => import("./components/Products/RecommentedProducts/RecommentedProducts"));

const NonRecommentedProducts = React.lazy(() => import("./components/Products/RecommentedProducts/NonRecommendedProducts"));

const Upload_Photograph_LI = React.lazy(() => import("./components/UploadDocument/AddressProof/Upload_Photograph_LI"));
const Upload_Photograph_Proposer = React.lazy(() => import("./components/UploadDocument/PhotoIDProof/Upload_Photograph_Proposer"));
const Upload_Photo_Id_LI = React.lazy(() => import("./components/UploadDocument/IncomeProof/Upload_Photo_Id_LI"));
const Upload_Photo_Id_Proposer = React.lazy(() => import("./components/UploadDocument/Proposer-Photo-ID/Upload_Photo_Id_Proposer"));
const Upload_Address_Proof_LI = React.lazy(() => import("./components/UploadDocument/AgeProof/Upload_Address_Proof_LI"));
const Upload_Address_Proof_Proposer = React.lazy(() => import("./components/UploadDocument/Proposer-Address-Proof/Upload_Address_Proof_Proposer"));
const Upload_PIO_Card_LI = React.lazy(() => import("./components/UploadDocument/pio-card-lifeinsured/Upload_PIO_Card_LI"));
const Upload_PIO_Card_Proposer = React.lazy(() => import("./components/UploadDocument/pio-card-proposer/Upload_PIO_Card_Proposer"));
const Upload_Passport_LI = React.lazy(() => import("./components/UploadDocument/passport-card-life-insured/Upload_Passport_LI"));
const Upload_Passport_Proposer = React.lazy(() => import("./components/UploadDocument/passport-card-proposer/Upload_Passport_Proposer"));
const BankUpload = React.lazy(() => import("./components/UploadDocument/Bank-Upload/BankUpload"));

const IdProof = React.lazy(() => import("./components/UploadDocument/IdProof/IdProof"));

const JointProposerPhotoID = React.lazy(() => import("./components/UploadDocument/Joint-Proposer-Photo-ID/JointProposerPhotoID"));
const JointProposerAddressProof = React.lazy(() => import("./components/UploadDocument/Joint-Proposer-AddressProof/JointProposerAddressProof"));

const JointPhotoFOS = React.lazy(() => import("./components/UploadDocument/JointPhotoFOS/JointPhotoFOS.js"));
const DynamicDocUploadProposer = React.lazy(() => import("./components/DynamicDocumentUpload/DynamicDocUploadProposer"));
const DynamicDocumentUploadLifeInsured = React.lazy(() => import("./components/DynamicDocumentUpload/DynamicDocumentUploadLifeInsured"));
const AthenaPayments = React.lazy(() => import("./components/payments/AthenaPayments"));

const SupervisorApproval = React.lazy(() => import("./components/SupervisorApproval/SupervisorApproval.js"));
const SupervisorApprovalManager = React.lazy(() => import("./components/SupervisorApproval/SupervisorApprovalManager.js"));
const OTPAuthentication = React.lazy(() => import("./components/OTPAuthentication/OTPAuthentication.js"));
const ESIRauthentication = React.lazy(() => import("./components/ESIR/ESIRauthentication.js"));
const ESIROTPAuth = React.lazy(() => import("./components/ESIR/ESIROTPAuth/ESIROTPAuth.js"));

const BIGIP = React.lazy(() => import("./components/BiForm/BIGIP"));
const BISIP = React.lazy(() => import("./components/BiForm/BISIP"));

const BIFortunePlus = React.lazy(() => import("./components/BiForm/FortunePlus"));
const BIFIB = React.lazy(() => import("./components/BiForm/BIFIB"));
const DhanSuraksha = React.lazy(() => import("./components/BiForm/BIDhanSuraksha"));
const BalVikasYojna = React.lazy(() => import("./components/BiForm/BIBalVikasYosjna.js"));
const ANWB = React.lazy(() => import("./components/BiForm/BIANWB"));
const BiPOSGIP = React.lazy(() => import("./components/BiForm/BiPOSGIP"));
const BIMIP = React.lazy(() => import("./components/BiForm/BiMIP.js"));
const BISIPP = React.lazy(() => import("./components/BiForm/BISIPPlatinum.js"));
const BIASIIP = React.lazy(() => import("./components/BiForm/BIASIIP.js"));

const SessionLogin = React.lazy(() => import("./components/Reports/SessionReport/SessionReports"));
const ProposalLogin = React.lazy(() => import("./components/Reports/ProposalLoginReport/ProposalLoginReport"));

const BITermPlan = React.lazy(() => import("./components/BiForm/TermPlan/BITermPlan.js"));
const BITermPlanPlatinum = React.lazy(() => import("./components/BiForm/TermPlan/BITermPlanPlatinum"));
const BITermPlanDiabetic = React.lazy(() => import("./components/BiForm/TermPlan/BITermPlanDiabetic"));
const BITermPlanPlatinum_V2 = React.lazy(() => import("./components/BiForm/TermPlan/BITermPlanPlatinum_V2"));

const BIAvivaSmartVitals = React.lazy(() => import("./components/BiForm/TermPlan/BIAvivaSmartVitals"));
const BIAvivaSmartVitalsV02 = React.lazy(() => import("./components/BiForm/TermPlan/BIAvivaSmartVitalsV02"));
const BiSmartMIP = React.lazy(() => import("./components/BiForm/BiSmartMIP"));

const RTSDetails = React.lazy(() => import("./components/RTSDetails/RTSDetails"));
const AddUpdateLead = React.lazy(() => import("./components/LeadStatusManagement/ProposerDetails/AddUpdateLead"));
const KYCDetailsPage = React.lazy(() => import("./components/KYCDetails/KYCDetailsPage"));

function App() {
  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  return (
    <React.Suspense fallback={<Loader formloader={true} />}>
      <Router>
        <div className="box-size">
          <Switch>
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>
            <Route path="/session" component={DefaultPage}></Route>
            <Route path="/login" component={Login_v2}></Route>
            <Route path="/forgotpassword" component={ForgotPassword}></Route>
            <Route path="/changepassword" component={ChangePassword}></Route>
            <Route path="/customer_review" component={CustomerReview} />

            <div>
              <div>
                <Sidebar />
                <div style={{ marginTop: "75px" }}>
                  <Route path="/home" component={HomePage}></Route>

                  <Route path="/bi-gip" component={BIGIP} />
                  <Route path="/bi-fib" component={BIFIB} />
                  <Route path="/bi-sip" component={BISIP} />
                  <Route path="/bi-fortune-plus" component={BIFortunePlus} />
                  <Route path="/bi-dhan-suraksha" component={DhanSuraksha} />
                  <Route path="/bi-bal-vikas-yojna" component={BalVikasYojna} />

                  <Route path="/bi-anwb" component={ANWB} />
                  <Route path="/bi-pos-gip" component={BiPOSGIP} />
                  <Route path="/bi-mip" component={BIMIP} />
                  <Route path="/bi-sipp" component={BISIPP} />
                  <Route path="/bi-asiip" component={BIASIIP} />
                  <Route path="/payments" component={AthenaPayments} />

                  <Route path="/supervisorApproval" component={SupervisorApproval} />
                  <Route path="/supervisorApprovalManager" component={SupervisorApprovalManager} />
                  <Route path="/otpauthentication" component={OTPAuthentication} />
                  <Route path="/kyc-details" component={KYCDetailsPage} />
                  <Route path="/esir" component={ESIRauthentication} />
                  <Route path="/esir-otp-auth" component={ESIROTPAuth} />
                  <Route path="/finalSubmit" component={FinalAppSubmission} />

                  <Route path="/bi-term-plan" component={BITermPlan} />
                  <Route path="/bi-term-plan-plantinum" component={BITermPlanPlatinum} />
                  <Route path="/bi-term-plan-plantinum-v2" component={BITermPlanPlatinum_V2} />
                  <Route path="/bi-term-plan-diabetic" component={BITermPlanDiabetic} />
                  <Route path="/bi-aviva-smart-vitals" component={BIAvivaSmartVitals} />
                  <Route path="/bi-aviva-smart-vitals-v02" component={BIAvivaSmartVitalsV02} />
                  <Route path="/bi-smart-mip" component={BiSmartMIP} />

                  <Route path="/uploaddoc/photograph_li" component={Upload_Photograph_LI} />
                  <Route path="/uploaddoc/photograph_proposer" component={Upload_Photograph_Proposer} />
                  <Route path="/uploaddoc/photo_id_li" component={Upload_Photo_Id_LI} />
                  <Route path="/uploaddoc/photo_id_proposer" component={Upload_Photo_Id_Proposer} />
                  <Route path="/uploaddoc/address_proof_li" component={Upload_Address_Proof_LI} />
                  <Route path="/uploaddoc/address_proof_proposer" component={Upload_Address_Proof_Proposer} />
                  <Route path="/uploaddoc/pio_card_li" component={Upload_PIO_Card_LI} />
                  <Route path="/uploaddoc/pio_card_proposer" component={Upload_PIO_Card_Proposer} />
                  <Route path="/uploaddoc/passport_li" component={Upload_Passport_LI} />
                  <Route path="/uploaddoc/passport_proposer" component={Upload_Passport_Proposer} />
                  <Route path="/uploaddoc/bankproof" component={BankUpload} />

                  <Route path="/uploaddoc/idProof" component={IdProof} />

                  <Route path="/uploaddoc/JointProposerPhotoID" component={JointProposerPhotoID} />

                  <Route path="/uploaddoc/jointproposerphotoaddressproof" component={JointProposerAddressProof} />

                  <Route path="/uploaddoc/jointphotofos" component={JointPhotoFOS} />

                  <Route path="/uploaddynamicdoc/proposer" component={DynamicDocUploadProposer} />
                  <Route path="/uploaddynamicdoc/lifeInsured" component={DynamicDocumentUploadLifeInsured} />
                  <Route path="/proposalLoginReport" component={ProposalLogin} />
                  <Route path="/sessionReportLogin" component={SessionLogin} />
                  <Route path="/proposalFormFilling/EInsurance" component={EInsurance} />
                  <Route path="/proposalFormFilling/DetailsOfPlan" component={DetailsOfPlan} />
                  {/* <Route path="/proposalFormFilling/aboutCustomer" component={AboutCustomer} /> */}
                  <Route path="/proposalFormFilling/aboutCustomer" component={AboutCustomer_v2} />
                  <Route path="/proposalFormFilling/financialDetails" component={FinancialDetails} />
                  <Route path="/proposalFormFilling/healthDetails" component={HealthDetails} />
                  <Route path="/proposalFormFilling/previousPolicy" component={PreviousPolicy} />
                  <Route path="/proposalFormFilling/nominationDetails" component={NominationDetails} />
                  <Route path="/proposalFormFilling/declaration" component={Declaration} />
                  <Route path="/proposalFormFilling/proposerDetails" component={ProposerDetails} />

                  <Route path="/customer_review" component={CustomerReview} />
                  <Route path="/leadMaster/:leadType" component={LeadMaster}></Route>
                  <Route path="/advisormaster/:advisortype" component={AdvisorMaster}></Route>

                  <Route path="/add-lead" component={AddUpdateLead}></Route>
                  <Route path="/leadmasterpage/statuslead" component={AddUpdateLead}></Route>
                  <Route path="/leadmasterpage/needanalysis/needanalysis" component={NeedAnalysis}></Route>
                  <Route path="/leadmasterpage/needanalysis/ProductRecommendation" component={ProductRecommendation}></Route>
                  <Route path="/leadmasterpage/needanalysis/ekyc" component={Ekyc}></Route>
                  <Route path="/leadmasterpage/leadtracker" component={LeadTracker}></Route>

                  <Route path="/leadmasterpage/leaddetails/personallead" component={PersonalDetails}></Route>
                  <Route path="/leadmasterpage/leaddetails/contactlead" component={ContactDetails}></Route>
                  <Route path="/leadmasterpage/leaddetails/professionallead" component={ProfessionalDetails}></Route>
                  <Route path="/leadmasterpage/leaddetails/existingLead" component={ExistingInsurance}></Route>
                  <Route path="/leadmasterpage/leaddetails/additionalLead" component={AdditionalDetails}></Route>

                  <Route path="/proposal-history" component={ProposalHistory}></Route>

                  <Route path="/notifypage" component={NotificationComp}></Route>

                  <Route path="/applications/all" component={ApplicationAll}></Route>
                  <Route path="/applications/wip" component={WIPApplication}></Route>
                  <Route path="/applications/pending" component={PendingApplication}></Route>
                  <Route path="/applications/issued" component={IssuedApplication}></Route>
                  <Route path="/applications/rts" component={RTSApplication}></Route>
                  <Route path="/rts-details/:proposalId" component={RTSDetails}></Route>
                  <Route path="/applications/rejected" component={RejectedApplication}></Route>
                </div>
              </div>

              <Route path="/products" component={LoanProducts} />
              <Route path="/recommendedProducts" component={RecommentedProducts} />
              <Route path="/non-recommendedProducts" component={NonRecommentedProducts} />
            </div>
          </Switch>
        </div>
        <Footer />
      </Router>
    </React.Suspense>
  );
}

export default Sentry.withProfiler(App);
// export default App;
